import { Component, OnInit, VERSION } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-tpp-instructions',
  templateUrl: './tpp-instructions.html',
  styleUrls: ['./tpp-instructions.css'],
  imports: [RouterModule]
})
export class TppInstructions {
  
}
